import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/functions'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    user: null,
    loading: false,
    error: null,
    site: {
      url: `${location.protocol}//${window.location.hostname}`
    },
    documents: [],
    notificationText: '',
    notificationQueue: [],
    notification: false,
    progress: 0
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setDocuments (state, payload) {
      state.documents = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    },
    addNotificationToQueue (state, payload) {
      state.notificationQueue.push(payload)
    },
    setNotificationState (state, payload) {
      state.notification = payload
    },
    setNotificationText (state, payload) {
      state.notificationText = payload
    },
    setNotificationQueue (state, payload) {
      state.notificationQueue = payload
    },
    setProgress (state, payload) {
      state.progress = payload
    }
  },
  actions: {
    signUserUp ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {
            const newUser = {
              id: user.user.uid,
              email: user.user.email
            }
            var updates = {}
            updates['/users/' + newUser.id] = { email: newUser.email }

            firebase.database().ref().update(updates)
              .then((data) => {
                commit('setUser', newUser)
                commit('setLoading', false)
              })
              .catch((error) => {
                commit('setLoading', false)
                commit('setError', error)
              })
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
          }
        )
    },
    signUserIn ({ commit, dispatch }, payload) {
      commit('setLoading', true)
      commit('clearError')
      // all we do is run the login which sets the users auth state and catch any errors
      // we don't trigger intitialise user here, instead we rely on onAuthStateChanged
      // in the main.js file to detect the user is logged in. THis then dispatches the initialize user
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
          }
        )
    },
    autoSignIn ({ commit, dispatch }, payload) {
      // commit('setUser', {id: payload.uid, email: payload.email})
      dispatch('initialiseUser', payload)
    },
    initialiseUser ({ commit, dispatch }, payload) {
      // get groupid from user's node
      firebase.database().ref('users/' + payload.uid).once('value')
        .then(data => {
          commit('setUser', { id: payload.uid, email: payload.email })
          dispatch('loadDocuments')
        })
        .catch(
          (error) => {
            commit('setError', error)
            commit('setLoading', false)
          }
        )
    },
    logout ({ commit }) {
      firebase.auth().signOut()
      commit('setUser', null)
      commit('setDocuments', null)
    },
    updateEmail ({ commit, getters }, payload) {
      commit('setLoading', true)
      // get usr's id
      const UserId = getters.user.id
      // update the FB Auth
      firebase.auth().currentUser.updateEmail(payload)
        .then(() => {
          // then make an object to update the FB user table
          const emailUpdate = {
            email: payload
          }
          firebase.database().ref('users').child(UserId).update(emailUpdate)
            .then(() => {
              // if good update the local state by using the spread to maintain the group and id
              commit('setUser', {
                ...getters.user,
                email: payload
              })
              // all done stop loading
              commit('setLoading', false)
              this.dispatch('addNotification', { text: 'Email updated.', type: 'success' })
            })
            .catch(error => {
              commit('setError', error)
              commit('setLoading', false)
            })
        })
        .catch(error => {
          commit('setError', error)
          commit('setLoading', false)
        })
    },
    updatePassword ({ commit }, payload) {
      commit('setLoading', true)
      firebase.auth().currentUser.updatePassword(payload)
        .then(() => {
          commit('setLoading', false)
          this.dispatch('addNotification', { text: 'Password updated.', type: 'success' })
        })
        .catch(error => {
          commit('setError', error)
          commit('setLoading', false)
        })
    },
    setError ({ commit }, payload) {
      commit('setError', payload)
    },
    clearError ({ commit }) {
      commit('clearError')
    },
    loadDocuments ({ commit, getters }) {
      commit('setLoading', true)
      firebase.database().ref('documents/' + getters.user.id).on('value', function (data) {
        const documents = []
        const obj = data.val()
        for (let key in obj) {
          documents.push(obj[key])
        }
        commit('setDocuments', documents)
        commit('setLoading', false)
      })
    },
    addDocument ({ commit, getters }, payload) {
      return new Promise((resolve, reject) => {
        // get userid
        const userID = getters.user.id
        // get a new document ref
        const ref = firebase.database().ref('documents').child(userID).push().key

        const filename = payload.documentObject.name
        // const ext = filename.slice(filename.lastIndexOf('.'))
        // Create a root reference
        var storageRef = firebase.storage().ref()
        // Add file to the userid/documentid/filename path
        var uploadTask = storageRef.child(`${userID}/${ref}/${filename}`).put(payload.documentObject)
        // Register three observers:
        // 1. 'state_changed' observer, called any time the state changes
        // 2. Error observer, called on failure
        // 3. Completion observer, called on successful completion
        uploadTask.on('state_changed', function (snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          // console.log('Upload is ' + progress + '% done')
          commit('setProgress', progress)
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              // console.log('Upload is paused')
              break
            case firebase.storage.TaskState.RUNNING: // or 'running'
              // console.log('Upload is running')
              break
          }
        }, function (error) {
          // Handle unsuccessful uploads
          console.log(error)
          // create a friendly error if it's the default firebase one or just pass the error
          let errorMessage = {}
          if (error.code === 'storage/unauthorized') {
            errorMessage['message'] = 'Upload issue, check the size of your file is under 10 megabytes and try again.'
          } else {
            errorMessage = error
          }
          commit('setError', errorMessage)
          commit('setLoading', false)
        }, function () {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            // console.log('File available at', downloadURL)
            payload.url = downloadURL
            payload.id = ref
            firebase.database().ref(`documents/${userID}/${ref}`).set(payload)
              .then(() => {
                commit('setLoading', false)
                // commit('setGroup', payload)
                resolve('true')
              })
              .catch(error => {
                commit('setError', error)
                reject(error)
                commit('setLoading', false)
              })
          })
        })
      })
    },
    removeDocument ({ commit, getters }, { fileId }) {
      const userID = getters.user.id
      const ref = fileId
      return firebase.database().ref(`documents/${userID}/${ref}`).remove()
    },
    setNotificationState ({ commit }, newState) {
      // simply sets the notification to true or false which controls the display of it
      commit('setNotificationState', newState)
    },
    addNotification ({ commit, getters }, payload) {
      // adds a notification to the queue and will show it if there is no queue
      // get current notification state true false for on or off
      const notification = getters.getNotificationState

      // now add the item to the queue
      commit('addNotificationToQueue', payload)

      // if its not showing then lets get this one and show it
      if (!notification) {
        this.dispatch('shiftNotificationQueue')
        this.dispatch('setNotificationState', true)
      }
    },
    shiftNotificationQueue ({ commit, getters }) {
      // performs array.shift() on the queue
      // get the current queue
      const reducedQueue = getters.getNotificationQueue
      // shift the first item off to use now
      const nextItem = reducedQueue.shift()
      // save the queueitems back to the queue
      commit('setNotificationQueue', reducedQueue)
      // set the current notification to the shifted off item
      commit('setNotificationText', nextItem)
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    site (state) {
      return state.site
    },
    documents (state) {
      return state.documents
    },
    getNotificationState (state) {
      return state.notification
    },
    getNotificationText (state) {
      return state.notificationText
    },
    getNotificationQueue (state) {
      return state.notificationQueue
    },
    progress (state) {
      return state.progress
    }
  }
})
